import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Municipality } from '../services/Municipality';
import { MunicipalityService } from '../services/municipality.service';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { from } from 'rxjs/observable/from';

@Injectable()
export class TokenClientIdInterceptorService implements HttpInterceptor {
  private municipality: Municipality;
  constructor(
    private _municipalityService: MunicipalityService,
    private _router: Router,
    private injector: Injector,
    private _activatedRoute: ActivatedRoute
  ) {
    this._municipalityService.currentMunicipality.subscribe(
      (data) => (this.municipality = data)
    );
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.handle(request, next));
  }
  async handle(request: HttpRequest<any>, next: HttpHandler) {
    //private-token შიდა სისტემისთვის
    //public-token მოქალაქის მხარეს
    const adminUrl = document.location.href.includes('admin');
    const tokenType = adminUrl ? 'private-token' : 'public-token';
    // const token = await this.storage.get(tokenType);

    let token: string;
    const queryToken = this._activatedRoute.snapshot.queryParams;
    if (queryToken && queryToken.token && queryToken.token !== 'null') {
      token = queryToken.token;
      localStorage.setItem(tokenType, String(token));
      this._router.navigate([], {
        queryParams: {
          token: null,
          clientId: null
        },
        queryParamsHandling: 'merge'
      });
    }
    if (queryToken && queryToken.token == 'null') {
      this._router.navigate([], {
        queryParams: {
          token: null,
          clientId: null
        },
        queryParamsHandling: 'merge'
      });
    }
    token = token || localStorage.getItem(tokenType);

    const ampersandOrQuestionMark: string =
      request.url.indexOf('?') < 0 ? '?' : '&';
    const alternativeClientId = localStorage.getItem('clientId');
    request = request.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
      url:
        request.url +
        `${ampersandOrQuestionMark}clientId=${
          this.municipality.clientId || alternativeClientId
        }`
    });
    return next
      .handle(request)
      .pipe(
        tap((evt) => {
          if (evt instanceof HttpResponse) {
            const clientId = localStorage.getItem('clientId');
            if (
              evt &&
              evt.body &&
              evt.body.result &&
              evt.body.result.data &&
              evt.body.result.data.clients &&
              Object.keys(evt.body.result.data.clients).length &&
              tokenType === 'private-token'
            ) {
              if (
                !clientId ||
                !Object.keys(evt.body.result.data.clients).includes(clientId)
              )
                this._municipalityService.changeClient(
                  Number(Object.keys(evt.body.result.data.clients)[0])
                );
            }
            const sessionToken = evt.headers.get('session-token');
            //private-token შიდა სისტემისთვის
            //public-token მოქალაქის მხარეს
            if (sessionToken) localStorage.setItem(tokenType, sessionToken);
          }
        })
      )
      .toPromise();
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/shared/token-client-id-interceptor.service.ts